import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MessageBoxWithIcon = _resolveComponent("MessageBoxWithIcon");
    const _component_ComponentSelection = _resolveComponent("ComponentSelection");
    const _component_PreventionBehavior = _resolveComponent("PreventionBehavior");
    const _component_AffectedComponent = _resolveComponent("AffectedComponent");
    const _component_Duration = _resolveComponent("Duration");
    const _component_Reason = _resolveComponent("Reason");
    const _component_RequiredFields = _resolveComponent("RequiredFields");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_MessageBoxWithIcon, {
            class: "mb-4",
            variant: _ctx.BootstrapVariant.INFO,
            "icon-name": "info",
            "icon-title": _ctx.tr('common.INFORMATION')
        }, {
            message: _withCtx(() => [
                _createElementVNode("span", {
                    innerHTML: _ctx.tr('viiu.componentMuting.MUTE_AFFECTED_COMPONENTS_INFO_BOX')
                }, null, 8, _hoisted_1)
            ]),
            _: 1
        }, 8, ["variant", "icon-title"]),
        _createVNode(_component_ComponentSelection, {
            modelValue: _ctx.selectedComponent,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedComponent) = $event)),
            class: "mb-4"
        }, null, 8, ["modelValue"]),
        (_ctx.shouldShowPreventionBehavior)
            ? (_openBlock(), _createBlock(_component_PreventionBehavior, {
                key: 0,
                class: _normalizeClass(_ctx.shouldShowAffectedComponents ? 'mb-3' : 'mb-4'),
                "model-value": _ctx.modelValue.shouldCascade,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => {
                    _ctx.$emit('update:model-value', { ..._ctx.modelValue, shouldCascade: value });
                })
            }, null, 8, ["class", "model-value"]))
            : _createCommentVNode("", true),
        (_ctx.shouldShowAffectedComponents)
            ? (_openBlock(), _createBlock(_component_AffectedComponent, {
                key: 1,
                class: "mb-4 pl-4",
                "show-header": false,
                "should-cascade": _ctx.modelValue.shouldCascade,
                "component-id": _ctx.modelValue.mutedComponent.componentId,
                "component-type": _ctx.modelValue.mutedComponent.componentType,
                "system-id": _ctx.modelValue.systemId
            }, null, 8, ["should-cascade", "component-id", "component-type", "system-id"]))
            : _createCommentVNode("", true),
        _createVNode(_component_Duration, {
            "model-value": [_ctx.modelValue.start, _ctx.modelValue.end],
            "fixed-start": false,
            class: "mb-4",
            "onUpdate:modelValue": _ctx.updateDuration
        }, null, 8, ["model-value", "onUpdate:modelValue"]),
        _createVNode(_component_Reason, {
            "model-value": _ctx.modelValue.reason,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => _ctx.$emit('update:model-value', { ..._ctx.modelValue, reason: value }))
        }, null, 8, ["model-value"]),
        _createVNode(_component_RequiredFields, { class: "mt-4" })
    ], 64));
}
